// extracted by mini-css-extract-plugin
export default {"getStarted":"GetStarted_getStarted__bCgMQ","getStarted_subContent":"GetStarted_getStarted_subContent__+Er8X","item":"GetStarted_item__-g654"};